module.exports = __webpack_public_path__ + "static/media/bd_bg.9aa0016c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bd_bg.png
// module id = 1622
// module chunks = 1